// extracted by mini-css-extract-plugin
var _1 = "vOgLgwSFEWd1gpDPrPX5";
var _2 = "vOgLgwSFEWd1gpDPrPX5";
var _3 = "sC1ALioUqRBF2r6gmQsv";
var _4 = "sC1ALioUqRBF2r6gmQsv";
var _5 = "KOqPYTq_I3RPnDWFFuPT";
var _6 = "ZrkL9n2Xl5SN2nBu1hXx";
export { _1 as "form-bottom-margin", _2 as "formBottomMargin", _3 as "inline-block", _4 as "inlineBlock", _5 as "minimum", _6 as "title" }
